<div #treeViewGroup class="fk-tree-view-group">
  @if (minimized) {
    <div
      (click)="toggleGroupHeader($event)">
      <button
        class="fk-tree-view-group--header"
        [fkDropdown]="!collapsed"
        [fkDropdownTemplate]="innerGroup"
        fkDropdownDirection="right"
        (click)="collapsed = !collapsed"
      >
        <fk-tree-view-item
          [item]="item"
          [isLastItem]="isLastItem"
          [isRootItem]="isRootItem"
          [minimized]="minimized"
          (click)="toggleSubTreeVisibility()">
          <fk-icon
            class="fk-tree-view-group--arrow"
            [name]="collapsed ? 'chevron-right' : 'chevron-down'"></fk-icon>
        </fk-tree-view-item>
      </button>
    </div>
    <div
      class="fk-tree-view-group--sub-tree fk-visually-hidden"
      [class.fk-tree-view-group--sub-tree__inner]="!isRootItem"
      [class.fk-hidden]="collapsed || minimized">
      @for (child of item.items; track $index; let last = $last) {
        @if (isGroup(child)) {
          <fk-tree-view-group
            [isLastItem]="last"
            [item]="child"></fk-tree-view-group>
        } @else {
          <fk-tree-view-item
            [isLastItem]="last"
            [item]="child"></fk-tree-view-item>
        }
      }
    </div>
  } @else {
    <div
      (mouseenter)="mouseEnterGroupHeader()"
      (mouseleave)="mouseLeaveGroupHeader()">
      <button class="fk-tree-view-group--header">
        <fk-tree-view-item
          [item]="item"
          [isLastItem]="isLastItem"
          [isRootItem]="isRootItem"
          [minimized]="minimized"
          (click)="toggleSubTreeVisibility()">
          <fk-icon
            class="fk-tree-view-group--arrow"
            [name]="collapsed ? 'chevron-right' : 'chevron-down'"></fk-icon>
        </fk-tree-view-item>
      </button>
      @if (minimized && !collapsed) {
        <div class="fk-tree-view-group--side-sub-menu-container fk-pl4">
          <div class="fk-tree-view-group--side-sub-menu fk-p3">
            @for (child of item.items; track $index; let last = $last) {
              @if (isGroup(child)) {
                <fk-tree-view-group
                  [isLastItem]="last"
                  [isRootItem]="true"
                  [item]="child"></fk-tree-view-group>
              } @else {
                <fk-tree-view-item
                  [isLastItem]="last"
                  [isRootItem]="true"
                  [item]="child"></fk-tree-view-item>
              }
            }
          </div>
        </div>
      }
    </div>
    <div
      class="fk-tree-view-group--sub-tree"
      [class.fk-tree-view-group--sub-tree__inner]="!isRootItem"
      [class.fk-hidden]="collapsed || minimized">
      @for (child of item.items; track $index; let last = $last) {
        @if (isGroup(child)) {
          <fk-tree-view-group
            [isLastItem]="last"
            [item]="child"></fk-tree-view-group>
        } @else {
          <fk-tree-view-item
            [isLastItem]="last"
            [item]="child"></fk-tree-view-item>
        }
      }
    </div>
  }
</div>

<ng-template #innerGroup>
  @if (minimized && !collapsed) {
    <div class="fk-tree-view-group--side-sub-menu-container">
      <div class="fk-tree-view-group--side-sub-menu fk-p3">
        @for (child of item.items; track $index; let last = $last) {
          @if (isGroup(child)) {
            <fk-tree-view-group
              [isLastItem]="last"
              [isRootItem]="true"
              [item]="child"></fk-tree-view-group>
          } @else {
            <fk-tree-view-item
              [isLastItem]="last"
              [isRootItem]="true"
              [item]="child"
              (click)="mouseLeaveGroupHeader()"></fk-tree-view-item>
          }
        }
      </div>
    </div>
  }
</ng-template>
